import * as React from 'react';

import Glyph from 'components/Glyph';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import { Props as NavItemProps } from './NavItem';

type Props = {
  name: string;
  items: React.ReactElement<NavItemProps>[];
  collapsible: boolean;
};

type State = {
  expanded: boolean;
};

export default class GroupedNavItem extends React.PureComponent<Props, State> {
  state = {
    expanded: true,
  };

  toggleExpandedState = () => {
    if (this.props.collapsible) {
      this.setState({ expanded: !this.state.expanded });
    }
  };

  render() {
    const nameWithDropdown = (
      <MediaObject figure="right" center>
        <Text>{this.props.name}</Text>
        <Glyph solo name={this.state.expanded ? 'chevron-down' : 'chevron-left'} />
      </MediaObject>
    );
    return (
      <li>
        <Link
          className="NavItem-collapseLink"
          data-test="grouped-navitem-collapse-link"
          onClick={this.toggleExpandedState}>
          {this.props.collapsible ? nameWithDropdown : this.props.name}
        </Link>
        {this.state.expanded && (
          <ul className="NavItem-nestedList">
            {this.props.items.map(item => React.cloneElement(item, { key: `${item.props.to}` }))}
          </ul>
        )}
      </li>
    );
  }
}
